import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="hero text-center relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10 py-[100px]">
        <div className="hero-content">
          <h1 className="text-5xl font-extrabold mb-5 leading-[1.2] text-white">
            Double Your Car Sales with LiveFunnel&trade; Leads
          </h1>
          <p className="text-xl max-w-[700px] mx-auto mb-8 text-gray-100 opacity-90">
            Create high-converting funnels, track performance metrics, and manage customer
            relationships all in one platform designed specifically for automotive dealerships.
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center sm:items-stretch gap-4 sm:space-x-5">
            <Link
              to="/signup"
              className="bg-superlist-btn-red-bg text-superlist-btn-primary-text border-2 border-superlist-btn-red-bg hover:bg-superlist-btn-red-bg-hover py-[15px] px-[30px] text-lg font-semibold rounded-lg transition-colors duration-300"
            >
              Start Free Trial
            </Link>
            <Link
              to="/demo"
              className="bg-superlist-btn-red-bg text-superlist-btn-primary-text border-2 border-superlist-btn-red-bg hover:bg-superlist-btn-red-bg-hover py-[15px] px-[30px] text-lg font-semibold rounded-lg transition-colors duration-300"
            >
              Schedule Demo
            </Link>
          </div>
          <div className="mt-10 flex justify-center">
            <div className="relative w-full max-w-4xl h-64 bg-gray-200 rounded-lg overflow-hidden">
              <div className="absolute inset-0 flex items-center justify-center">
                <p className="text-gray-500">Dashboard Preview</p>
              </div>
            </div>
          </div>
          <div className="mt-12 flex flex-wrap justify-center gap-6">
            <div className="text-center">
              <div className="text-3xl font-bold text-white">1000+</div>
              <p className="text-gray-100 opacity-90">Dealerships Trust Us</p>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white">3x</div>
              <p className="text-gray-100 opacity-90">Faster Lead Conversion</p>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white">24/7</div>
              <p className="text-gray-100 opacity-90">Dedicated Support</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
